module.exports = __webpack_public_path__ + "./Paul_fdb8a31e6dd47f0d436f540fcbbad869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Paul.jpg
// module id = 502
// module chunks = 0